<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t('helpCenter.introduction.features') }}</p><img src="/img/up-arrow.7f2fb856.svg"
                                alt="logo" class="right-arrow">
                            <p>{{ $t('helpCenter.introduction.helpCenter') }}</p><img src="/img/up-arrow.7f2fb856.svg"
                                alt="logo" class="right-arrow"><a href="#">{{ $t('helpCenter.introduction.introduction')
                                }}</a>
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne"><button class="accordion-button"
                                            type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                            aria-expanded="true" aria-controls="collapseOne">
                                            <p>{{ $t('helpCenter.introduction.onThisPage') }}</p>
                                            <span class="down_up_icon"><img src="/img/up_arrow_side.7f2fb856.svg"
                                                    alt=""></span>

                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="tableOfContents-list">
                                                <ul id="side_section_info">

                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#i-creating-a-portal-link' }">
                                                        <a @click="scrollTo('#i-creating-a-portal')">{{
                                                            $t('helpCenter.introduction.creatingPortal') }}
                                                        </a>
                                                    </li>

                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#ii-creating-a-portal-link' }">
                                                        <a @click="scrollTo('#ii-creating-categories')">{{
                                                            $t('helpCenter.introduction.creatingCategories') }}
                                                        </a>
                                                    </li>
                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#iii-creating-articles-link' }">
                                                        <a @click="scrollTo('#iii-creating-articles')">{{
                                                            $t('helpCenter.introduction.creatingArticles') }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="Introduction-details text-align-left">
                            <h1>{{ $t('doc.product.HelpCenter') }}</h1>

                            <p>{{ $t('helpCenter.introduction.creatingPortals.withhelpcenter') }}</p>
                            <p>{{ $t('helpCenter.introduction.creatingPortals.Please') }}</p>
                        </div>

                        <div class="channels-info">
                            <div class="channels-title code-info">

                                <h2 class="anchorarticlenew" id="i-creating-a-portal">{{
                                    $t('helpCenter.introduction.creatingPortals.title') }}<a class="hash-link"
                                        href="#i-creating-a-portal" title="Direct link to heading">&ZeroWidthSpace;</a>
                                </h2>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step1') }}</strong> {{
                                    $t('helpCenter.introduction.creatingPortals.step1Content') }}</p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBMGF0VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--75c692c975b2beba0b089cb77c41d93c913524a4/help%20center%20in%20chatwoot.png"
                                        class="img_E7b_"></p>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step2') }}</strong>{{
                                    $t('helpCenter.introduction.creatingPortals.step2Content') }}</p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBMHV0VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--3769e42313f6f19c7080f9ac6632a3d4fd42203e/create%20a%20portal%20in%20help%20center.png"
                                        class="img_E7b_"></p>
                                <p>These fields are explained below:</p>
                                <ol class="channels-menu-ol">
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Logo') }}</strong></p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.Upload') }}</p>
                                    </li>
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.createName')
                                                }}</strong></p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.Name') }}</p>
                                    </li>
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Slug') }}</strong></p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.auto-generated') }}</p>
                                    </li>
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Custom') }}</strong>
                                        </p>
                                        <p>
                                            {{ $t('helpCenter.introduction.creatingPortals.domain') }}
                                        </p>
                                    </li>
                                </ol>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.Click') }}</p>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.portal') }}</p>
                                <h2 class="anchorarticlenew" id="ii-creating-categories">{{
                                    $t('helpCenter.introduction.creatingPortals.Creating') }}<a class="hash-link"
                                        href="#ii-creating-categories"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h2>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.exist') }}</p>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step1') }}</strong>{{
                                    $t('helpCenter.introduction.creatingPortals.Clickthe') }} <code>+</code>{{
                                    $t('helpCenter.introduction.creatingPortals.alongside') }} </p>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step2') }}</strong>{{
                                    $t('helpCenter.introduction.creatingPortals.modal') }} </p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBMmF0VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--4a1192c8db7ce6541b8adf0c872a0a6d022e610a/creating%20a%20category%20in%20help%20center.png"
                                        class="img_E7b_"></p>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.fields') }}</p>
                                <ol class="channels-menu-ol">
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Creating') }}</strong>
                                        </p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.category') }}</p>
                                    </li>
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Slug') }}</strong></p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.auto-generated') }}</p>
                                    </li>
                                    <li>
                                        <p><strong>{{ $t('helpCenter.introduction.creatingPortals.Description')
                                                }}</strong></p>
                                        <p>{{ $t('helpCenter.introduction.creatingPortals.Describe') }}</p>
                                    </li>
                                </ol>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.Clickcategory') }}</p>
                                <h2 class="anchorarticlenew" id="iii-creating-articles">
                                    {{ $t('helpCenter.introduction.creatingPortals.IIICreatingarticles') }}<a
                                        class="hash-link" href="#iii-creating-articles"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h2>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.Finally') }}</p>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step1') }}</strong>{{
                                    $t('helpCenter.introduction.creatingPortals.NewArticle') }}</p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNEd0VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--5923b0b92b58bdfae24709c292f2e6e49fba5190/new%20article.png"
                                        class="img_E7b_"></p>
                                <p><strong>{{ $t('helpCenter.introduction.creatingPortals.step2') }}</strong>{{
                                    $t('helpCenter.introduction.creatingPortals.sidebar') }}</p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNDZ0VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--1fff825cd2ff75ba253d76ff8ea4ce302ff8dbbc/writing%20an%20article%20in%20help%20center.png"
                                        class="img_E7b_"></p>
                                <p>{{ $t('helpCenter.introduction.creatingPortals.Preview') }}</p>
                                <p><img loading="lazy"
                                        src="https://app.chatwoot.com/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBNW10VHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--5a1f9ebd7b1a45390359c8b97d29b0bae632b0a8/published%20article.png"
                                        class="img_E7b_"></p>

                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('helpCenter.introduction.creatingPortals.Editthispage') }}</a>
                            </div> -->
                            <p>{{ $t('helpCenter.introduction.creatingPortals.Editupdated') }} <span class="dark">{{
                                    $t('helpCenter.introduction.creatingPortals.Edit421') }}</span>{{
                                $t('helpCenter.introduction.creatingPortals.by') }} <span class="dark">{{
                                    $t('helpCenter.introduction.creatingPortals.Pranav') }} </span>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('helpCenter.introduction.creatingPortals.Previous') }}</p>

                                    <router-link to="/docs/product/features/campaigns/ongoing"
                                        class="introduction-account">
                                        <span>«</span> {{ $t('helpCenter.introduction.creatingPortals.PreviousOngoing')
                                        }}
                                    </router-link>


                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('helpCenter.introduction.creatingPortals.Next') }}</p>


                                    <router-link to="/docs/product/features/help-center/configure-ssl-for-help-center">
                                        {{ $t('helpCenter.introduction.creatingPortals.Configure') }} <span>»</span>
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <section class="tableOfContents">
                        <div class="tableOfContents-list">
                            <ul id="side_section_info">

                                <li :class="{ 'active_menu_item': rightPanelMenuItem === '#i-creating-a-portal-link' }">
                                    <a id="#i-creating-a-portal-link" @click="scrollTo('#i-creating-a-portal')">{{
                                        $t('helpCenter.introduction.creatingPortal') }}
                                    </a></li>
                                <li
                                    :class="{ 'active_menu_item': rightPanelMenuItem === '#ii-creating-categories-link' }">
                                    <a id="#ii-creating-categories-link" @click="scrollTo('#ii-creating-categories')">{{
                                        $t('helpCenter.introduction.creatingCategories') }}
                                    </a></li>
                                <li
                                    :class="{ 'active_menu_item': rightPanelMenuItem === '#iii-creating-articles-link' }">
                                    <a id="#iii-creating-articles-link" @click="scrollTo('#iii-creating-articles')">{{
                                        $t('helpCenter.introduction.creatingArticles') }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import SideBar from "@/components/SideBar.vue";
    import MainContent from "@/components/MainContent.vue";

    export default {
        name: 'help-center',
        data() {
            return {
                isToggle: false,
                activeMenuItem: null,
                rightPanelMenuItem: null
            }
        },
        components: {
            Header,
            Footer,
            SideBar,
            MainContent
        },
        mounted() {
            window.addEventListener('scroll', this.setActiveMenuItem);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.setActiveMenuItem);
        },
        methods: {
            scrollTo(selector) {
                const element = document.querySelector(selector);
                if (element) {
                    const offset = 106;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = element.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                    this.rightPanelMenuItem = `${selector}-link`
                }
            },
            setActiveMenuItem() {
                const scrollPosition = window.scrollY;
                const menuItems = document.querySelectorAll('#side_section_info li');
                this.activeMenuItem = null
                for (let i = menuItems.length - 1; i >= 0; i--) {
                    const menuItem = menuItems[i];
                    // console.log(menuItem)
                    const target = document.querySelector(menuItem.querySelector('a').getAttribute('id')?.replace(/-link(?=[^-]*$)/, ""));
                    if ((target?.offsetTop - 200) <= scrollPosition) {
                        let tempEle
                        if (menuItem) {
                            tempEle = menuItem?.getAttribute('id')
                            let targetID = target?.getAttribute('id')
                            this.rightPanelMenuItem = `#${targetID}-link`
                            // menuItem?.classList.add("active_menu_item");
                        }
                        this.activeMenuItem = tempEle
                        return;
                    }
                }
            },
            handleToggle() {
                this.isToggle = !this.isToggle
            }
        },
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 0px;
    }
</style>